import React, { Component, Fragment } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { Typeahead } from "react-bootstrap-typeahead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faCalendarAlt,
  faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";

import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";

import Validation from "../../services/Validation";
import SalesReportService from "../../services/SalesReportService";
import ModalService from "../../services/ModalService";

import { messages } from "../../constants/constant.message";
import "./SalesReport.css";

const {
  EMPTY_CUSTOMER,
  EMPTY_DATE,
  EMPTY_QUANTITY,
  EMPTY_TYRE_DESCRIPTION,
} = messages.SALES_REPORT;
const defaultTyreObj = {
  tyreType: {
    value: "tbr",
    valid: null,
    touched: true,
    message: null,
    nullValue: null,
  },
  tyreDescription: {
    value: "",
    valid: null,
    touched: false,
    message: null,
    nullValue: null,
  },
  tyreQuantity: {
    value: "",
    valid: null,
    touched: false,
    message: null,
    nullValue: null,
  },
  saleDate: {
    value: "",
    valid: null,
    touched: false,
    message: null,
    nullValue: null,
  },
  saleType: {
    value: "direct",
    valid: null,
    touched: true,
    message: null,
    nullValue: null,
  },
};
class AddSalesDataFM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerData: [],
      tbbSkuData: [],
      tbrSkuData: [],
      salesData: {},
      controls: {
        customer: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        saleDate: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        saleType: {
          value: "direct",
          valid: null,
          touched: true,
          message: null,
          nullValue: null,
        },
        tyre: [JSON.parse(JSON.stringify(defaultTyreObj))],
        tyreType: {
          value: "tbr",
          valid: null,
          touched: true,
          message: null,
          nullValue: null,
        },
        tyreDescription: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        tyreQuantity: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
      },
      isValidForm: false,
      isLoading: false,
    };
  }

  componentWillMount() {
    this.getFleet();
    this.getTBBSkuData();
    this.getTBRSkuData();

    // this.getSkuData();
  }

  componentWillUnmount() {
    document.body.style.overflowY = "auto";
  }

  async componentWillReceiveProps(nextProps) {
    if (
      nextProps.isEdit === true &&
      (nextProps.sales && nextProps.sales !== "fetchData") &&
      (!this.props.sales ||
        (this.props.sales &&
          this.props.sales.uuid !== nextProps.sales.uuid &&
          this.props.sales.direct_tbb !== nextProps.sales.direct_tbb &&
          this.props.sales.direct_tbr !== nextProps.sales.direct_tbr &&
          this.props.sales.indirect_tbb !== nextProps.sales.indirect_tbb &&
          this.props.sales.indirect_tbr !== nextProps.sales.indirect_tbr &&
          this.props.sales.tyre_description !==
          nextProps.sales.tyre_description))
    ) {
      // this.resetControl();
      let { sales, userDetail } = nextProps;
      this.resetControl();
      const { controls } = this.state;
      const {
        // saleDate,
        // saleType,
        customer,
        // tyreDescription,
        // tyreQuantity,
        // tyreType,
        tyre,
      } = controls;
      // direct_tbb: 0
      // direct_tbr: 0
      // indirect_tbb: 100
      // indirect_tbr: 0
      // sales_date: "2019-12-03T14:20:23.000Z"
      // tyre_description: "10.00R20_JETSTEEL_114_16PR_K_TT"
      // uuid: "e137aa2b-70ec-4c0e-9d88-9f66886bf572"

      const salesData = await this.getSales(sales.uuid);
      this.setState({ salesData });

      // if (salesData.direct) {
      //   saleType.value = 'direct'
      // } else {
      //   saleType.value = 'indirect'
      // }

      // if (salesData.sales_date) {
      //   saleDate.value = new Date(salesData.sales_date);
      // }

      if (salesData.product.length > 0) {
        const tyreData = salesData.product[0];
        const description = { sku_id: null, discription: null };
        if (tyreData.tbr) {
          tyre[0].tyreType.value = "tbr";
        } else {
          tyre[0].tyreType.value = "tbb";
        }

        if (salesData.direct) {
          tyre[0].saleType.value = "direct";
        } else {
          tyre[0].saleType.value = "indirect";
        }

        if (salesData.sales_date) {
          tyre[0].saleDate.value = new Date(salesData.sales_date);
        }

        if (tyreData.hasOwnProperty("qty")) {
          tyre[0].tyreQuantity.value = tyreData.qty;
        }
        if (tyreData.tyre_description && tyreData.material_name) {
          description.discription = tyreData.tyre_description;
          description.sku_id = tyreData.material_name;
          tyre[0].tyreDescription.value = description;
        }
      }
      let user = { uuid: null, business_name: null, member_id: null };
      let u = JSON.parse(JSON.stringify(userDetail));
      if (u.uuid) {
        user.uuid = u.uuid;
      }
      if (u.name) {
        user.business_name = u.name;
      }
      if (u.memberId) {
        user.member_id = u.memberId;
      }
      customer.value = user;
      this.setState({ controls });
    }
  }

  handleInputChange = (e) => {
    console.log("e", e);
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;

    controls[controlName].value = controlValue;
    controls[controlName].touched = true;

    this.setState({ controls }, () => {
      // if (controlName === 'tyreType') {
      //   this.getSkuData();
      // }
    });

    this.handleValidation(false);
  };

  handleTyreInputChange = (e, index) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    const { tyre } = controls;

    const tyreObj = tyre[index];

    tyreObj[controlName].value = controlValue;
    tyreObj[controlName].touched = true;

    this.setState({ controls }, () => {
      if (controlName === "tyreType") {
        tyreObj["tyreDescription"].value = "";

        // this.getSkuData();
      }
    });

    this.handleValidation(false);
  };

  handleValidation = (isSubmit) => {
    const { controls } = this.state;
    let { isValidForm } = this.state;
    let {
      customer,
      // saleDate,
      // saleType,
      // tyreType,
      // tyreDescription,
      // tyreQuantity,
      tyre,
    } = controls;

    if (customer.touched === true || isSubmit) {
      customer = Validation.notNullValidator(customer);
      customer.valid = !!customer.value;
    }

    // if (saleDate.touched === true || isSubmit) {
    //   saleDate = Validation.notNullValidator(saleDate);
    //   saleDate.valid = !!saleDate.value;
    // }

    // if (saleType.touched === true) {
    // saleType = Validation.notNullValidator(saleType);
    // saleType.valid = !!saleType.value;
    // }

    // if (tyreType.touched === true) {
    // tyreType = Validation.notNullValidator(tyreType);
    // tyreType.valid = !!tyreType.value;
    // }

    // if (tyreDescription.touched === true || isSubmit) {
    //   tyreDescription = Validation.notNullValidator(tyreDescription);
    //   tyreDescription.valid = !!tyreDescription.value;
    // }

    // if (tyreQuantity.touched === true || isSubmit) {
    //   tyreQuantity = Validation.notNullValidator(tyreQuantity);
    //   tyreQuantity.valid = !!tyreQuantity.value;
    // }

    for (let i = 0; i < tyre.length; i++) {
      const currentData = tyre[i];
      if (currentData.tyreDescription.touched === true || isSubmit) {
        currentData.tyreDescription = Validation.notNullValidator(
          currentData.tyreDescription
        );
        currentData.tyreDescription.valid = !!currentData.tyreDescription.value;
      }

      if (currentData.tyreQuantity.touched === true || isSubmit) {
        currentData.tyreQuantity = Validation.notNullValidator(
          currentData.tyreQuantity
        );
        currentData.tyreQuantity.valid = !!currentData.tyreQuantity.value;
      }

      if (currentData.saleDate.touched === true || isSubmit) {
        currentData.saleDate = Validation.notNullValidator(
          currentData.saleDate
        );
        currentData.saleDate.valid = !!currentData.saleDate.value;
      }
    }

    let isTyreDetailValid = true;
    for (let i = 0; i < tyre.length; i++) {
      const currentData = tyre[i];
      isTyreDetailValid =
        isTyreDetailValid &&
        (currentData.tyreDescription.valid &&
          currentData.tyreQuantity.valid &&
          currentData.saleDate.valid);
    }
    if (
      customer.valid &&
      isTyreDetailValid
      // saleType.valid && tyreType.valid &&
      // tyreDescription.valid && tyreQuantity.valid
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }

    this.setState({ isValidForm });
    return isValidForm;
  };

  getFleet = async () => {
    let { customerData } = this.state;
    try {
      const { data } = await SalesReportService.getFleets();
      if (data) {
        customerData = data.data;
      }
      this.setState({ customerData });
    } catch (error) {
      console.log("error");
    }
  };

  getTBRSkuData = async () => {
    const { controls } = this.state;
    let { tbrSkuData } = this.state;
    try {
      // controls.tyreDescription.value = '';
      const { data } = await SalesReportService.getSKU("tbr");
      if (data) {
        tbrSkuData = data.data;
      }
      this.setState({ tbrSkuData, controls });
    } catch (error) {
      console.log("error");
    }
  };

  getTBBSkuData = async () => {
    const { controls } = this.state;
    let { tbbSkuData } = this.state;
    try {
      // controls.tyreDescription.value = '';
      const { data } = await SalesReportService.getSKU("tbb");
      if (data) {
        tbbSkuData = data.data;
      }
      this.setState({ tbbSkuData, controls });
    } catch (error) {
      console.log("error");
    }
  };

  saveSale = async () => {
    try {
      if (this.state.isLoading === true) {
        return;
      }
      const isFormValid = this.handleValidation(true);
      if (!isFormValid) {
        return;
      }
      const obj = this.buildObj();
      this.setState({ isLoading: true });

      const { data } = await SalesReportService.saveSale(obj);
      if (data) {
        ModalService.openAlert("Congratulations!", data.message, "success");
        this.resetControl();
        this.setState({ isLoading: false });
        this.props.openCloseSideBar("fetchData");
      }
    } catch (e) {
      let err =
        e.response && e.response.data && e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      const message =
        err && err.message ? err.message : messages.COMMON.ERROR_MESSAGE;
      this.setState({ isLoading: false });
      ModalService.openAlert("Sorry!", message, "error");
    }
  };

  updateSale = async () => {
    try {
      const isFormValid = this.handleValidation(true);
      if (!isFormValid) {
        return;
      }
      // const { sales } = this.props;
      const { salesData } = this.state;
      const obj = this.buildObj();
      obj.id = salesData.id;
      this.setState({ isLoading: true });
      // return;
      const { data } = await SalesReportService.editSales(obj);
      if (data) {
        ModalService.openAlert("Congratulations!", data.message, "success");
        this.resetControl();
        this.setState({ isLoading: false });
        this.props.openCloseSideBar(true);
      }
    } catch (e) {
      let err =
        e.response && e.response.data && e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      const message =
        err && err.message ? err.message : messages.COMMON.ERROR_MESSAGE;
      this.setState({ isLoading: false });
      ModalService.openAlert("Sorry!", message, "error");
    }
  };

  getSales = async (id) => {
    try {
      this.setState({ isLoading: true });
      const { data } = await SalesReportService.getSales(id);
      this.setState({ isLoading: false });
      const salesData = data.data;
      return salesData;
      // if (data) {
      //   ModalService.openAlert('Congratulations!', data.message, 'success');
      //   this.resetControl();
      //   this.setState({ isLoading: false });
      //   this.props.openCloseSideBar('fetchData');
      // }
    } catch (error) {
      console.error("error", error);
      this.setState({ isLoading: false });
      ModalService.openAlert("Sorry!", messages.COMMON.ERROR_MESSAGE, "error");
    }
  };

  addTyreObject = () => {
    const { controls } = this.state;
    const { tyre } = controls;
    let defaultTyreObjData = defaultTyreObj;
    let saleTypeData = tyre[tyre.length - 1];
    defaultTyreObjData.saleType.value = saleTypeData.saleType.value;
    tyre.push(JSON.parse(JSON.stringify(defaultTyreObjData)));
    this.setState({ controls });
  };

  removeTyreObject = (index) => {
    const { controls } = this.state;
    const { tyre } = controls;
    tyre.splice(index, 1);
    // tyre.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    this.setState({ controls });
  };

  closeSideBar = () => {
    document.body.style.overflowY = "auto";
    this.resetControl();
    this.props.openCloseSideBar();
  };

  buildObj() {
    const { controls } = this.state;
    const { tyre } = controls;

    const obj = {
      fleet_id: controls.customer.value.uuid,
      // tbr: controls.tyreType.value === 'tbr',
      // tyre_description: controls.tyreDescription.value.sku_id,
      // qty: +controls.tyreQuantity.value
    };

    let product = [];
    for (let i = 0; i < tyre.length; i++) {
      let currentData = tyre[i];
      let obj = {
        tbr: currentData.tyreType.value === "tbr",
        tyre_description: currentData.tyreDescription.value.sku_id,
        qty: currentData.tyreQuantity.value,
        sales_date: currentData.saleDate.value,
        direct: currentData.saleType.value === "direct",
      };
      product.push(obj);
    }
    obj["product"] = product;
    return obj;
  }

  resetControl() {
    let { controls } = this.state;
    controls = {
      customer: {
        value: "",
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      saleDate: {
        value: "",
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      saleType: {
        value: "direct",
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      tyre: [JSON.parse(JSON.stringify(defaultTyreObj))],
      tyreType: {
        value: "tbr",
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      tyreDescription: {
        value: "",
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      tyreQuantity: {
        value: "",
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
    };

    this.setState({ controls });
  }

  render() {
    const {
      // isValidForm,
      customerData,
      controls,
      // skuData,
      tbbSkuData,
      tbrSkuData,
    } = this.state;
    const { isEdit } = this.props;
    const {
      customer,
      // saleDate,
      // saleType,
      // tyreType,
      // tyreDescription,
      // tyreQuantity,
      tyre,
    } = controls;
    const tyreElements = tyre.map((t, index) => (
      <Fragment>
        <div id="sales" className="tyre-container">
          {index !== 0 && (
            <div className="minus-button">
              <FontAwesomeIcon
                icon={faMinusCircle}
                className="cursor-pointer"
                style={{
                  color: "#fdbb1f",
                  fontSize: "19px",
                  backgroundColor: "white",
                }}
                onClick={this.removeTyreObject.bind(this, index)}
              />
            </div>
          )}
          <Row
            className="c-top-15"
            style={
              index > 0
                ? { marginLeft: "0px", marginRight: "0px", marginTop: "18px" }
                : { marginLeft: "0px", marginRight: "0px" }
            }
          >
            <Col>
              <div>
                <Label className="enter-sale-label">
                  Select Date<span className="required-field"> *</span>
                </Label>
              </div>
              <Label
                onClick={(e) =>
                  this[`refSaleDate${index}`].state.open && e.preventDefault()
                }
                style={{ width: "100%" }}
              >
                <InputGroup className="social-detail-date">
                  <DatePicker
                    className="form-control"
                    selected={t.saleDate.value}
                    onChange={(e) =>
                      this.handleTyreInputChange(
                        { target: { name: "saleDate", value: e } },
                        index
                      )
                    }
                    showMonthDropdown
                    ref={(r) => (this[`refSaleDate${index}`] = r)}
                    placeholderText="Select Date"
                    // shouldCloseOnSelect={true}

                    disabled={isEdit ? true : false}
                    showYearDropdown
                    shouldCloseOnSelect
                    maxDate={new Date()}
                    dropdownMode="select"
                    style={{ zIndex: "auto" }}
                    dateFormat="dd/MM/yyyy"
                  // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                  />
                  <InputGroupAddon addonType="append">
                    <div
                      className="input-group-text"
                      style={{ zIndex: "auto !important", cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        htmlFor="datepicker"
                        icon={faCalendarAlt}
                      />
                    </div>
                  </InputGroupAddon>
                </InputGroup>
                <div className="error-container">
                  {t.saleDate.nullValue && (
                    <div className="error">{EMPTY_DATE}</div>
                  )}
                </div>
              </Label>
            </Col>

            {/* <Col>
              <div>
                <Label className="enter-sale-label">
                  Select Sales Type<span className="required-field"> *</span>
                </Label>
                <div>
                  <label className="custom-checkboax-radio--container">
                    <input
                      type="checkbox"
                      name="saleType"
                      value="direct"
                      checked={t.saleType.value === "direct"}
                      onChange={(e) => this.handleTyreInputChange(e, index)}
                    />
                    <span className="checkmark-radio" />
                  </label>
                  <span style={{ marginLeft: "10px" }}>Direct</span>
                  &nbsp;&nbsp;&nbsp;
                  <label className="custom-checkboax-radio--container">
                    <input
                      type="checkbox"
                      name="saleType"
                      value="indirect"
                      checked={t.saleType.value === "indirect"}
                      onChange={(e) => this.handleTyreInputChange(e, index)}
                    />
                    <span className="checkmark-radio" />
                  </label>
                  <span style={{ marginLeft: "10px" }}>Indirect</span>
                </div>
              </div>
            </Col> */}
          </Row>

          <Row
            className="c-top-15"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <Col>
              <div>
                <Label className="enter-sale-label">
                  Select Tyre Type<span className="required-field"> *</span>
                </Label>
                <div>
                  <label className="custom-checkboax-radio--container">
                    <input
                      type="checkbox"
                      name="tyreType"
                      value="tbr"
                      checked={t.tyreType.value === "tbr"}
                      onChange={(e) => this.handleTyreInputChange(e, index)}
                    />
                    <span className="checkmark-radio" />
                  </label>
                  <span style={{ marginLeft: "10px" }}>TBR</span>
                  &nbsp;&nbsp;&nbsp;
                  <label className="custom-checkboax-radio--container">
                    <input
                      type="checkbox"
                      name="tyreType"
                      value="tbb"
                      checked={t.tyreType.value === "tbb"}
                      onChange={(e) => this.handleTyreInputChange(e, index)}
                    />
                    <span className="checkmark-radio" />
                  </label>
                  <span style={{ marginLeft: "10px" }}>TBB</span>
                </div>
              </div>
            </Col>
          </Row>

          <Row
            className="c-top-15"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <Col xl="8" md="8" sm="8" xs="8">
              <div>
                <Label className="enter-sale-label">
                  Tyre Description<span className="required-field"> *</span>
                </Label>
                <Typeahead
                  // labelKey="discription"
                  id={"description" + index}
                  options={t.tyreType.value === "tbr" ? tbrSkuData : tbbSkuData}
                  placeholder="Type here"
                  filterBy={["sku_id", "discription"]}
                  labelKey={(option) =>
                    `${option.discription} - ${option.sku_id}`
                  }
                  onChange={(e) => {
                    this.handleTyreInputChange(
                      { target: { name: "tyreDescription", value: e && e[0] } },
                      index
                    );
                  }}
                  selected={
                    t.tyreDescription.value && t.tyreDescription.value.sku_id
                      ? [t.tyreDescription.value]
                      : []
                  }
                />
                <div className="error-container">
                  {t.tyreDescription.nullValue && (
                    <div className="error">{EMPTY_TYRE_DESCRIPTION}</div>
                  )}
                </div>
              </div>
            </Col>
            <Col>
              <div>
                <Label className="enter-sale-label">
                  Qty<span className="required-field"> *</span>
                </Label>
                <Input
                  type="number"
                  name="tyreQuantity"
                  id="tyreQuantity"
                  placeholder="Type here"
                  value={t.tyreQuantity.value}
                  onChange={(e) => this.handleTyreInputChange(e, index)}
                />
                <div className="error-container">
                  {t.tyreQuantity.nullValue && (
                    <div className="error">{EMPTY_QUANTITY}</div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Fragment>
    ));
    return (
      <>
        <div style={{ marginTop: "60px" }}>
          {this.state.isLoading && (
            <CustomSpinner marginTop="50%"></CustomSpinner>
          )}
          <div className="drawer-header">
            <span className="drawer-title">
              {isEdit ? "Edit" : "Enter A"} Sale
            </span>
            <img
              className="cursor-pointer"
              src="images/close.svg"
              alt="cancel"
              onClick={this.closeSideBar}
            />
          </div>
          <hr style={{ border: "solid 1px #ced4da" }} />
          <Row
            className="c-top-15"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <Col>
              <div>
                <Label className="enter-sale-label">
                  Select Customer<span className="required-field"> *</span>
                </Label>
              </div>
              <div className="d-flex-row vehical-sku-id-search">
                <Typeahead
                  id="customer"
                  filterBy={["business_name", "member_id"]}
                  labelKey={(option) =>
                    `${option.business_name} (${option.member_id})`
                  }
                  options={customerData}
                  disabled={isEdit ? true : false}
                  placeholder="Type here"
                  onChange={(e) => {
                    this.handleInputChange({
                      target: { name: "customer", value: e && e[0] },
                    });
                  }}
                  selected={customer.value ? [customer.value] : []}
                />

                <InputGroupAddon
                  addonType="append"
                  className="serach-icon"
                  style={{ marginTop: "0px" }}
                >
                  <div
                    className="input-group-text"
                    style={{ paddingRight: "5px", marginTop: "-1px" }}
                  >
                    <FontAwesomeIcon htmlFor="datepicker" icon={faSearch} />
                  </div>
                </InputGroupAddon>
              </div>
              <div className="error-container">
                {customer.nullValue && (
                  <div className="error">{EMPTY_CUSTOMER}</div>
                )}
              </div>
            </Col>
          </Row>

          {/* <Row className="c-top-15" style={{ marginLeft: '0px', marginRight: '0px' }}>
          <Col>
            <div>
              <Label className="enter-sale-label">
                Select Tyre Type<span className="required-field"> *</span>
              </Label>
              <div>
                <label className="custom-checkboax-radio--container">
                  <input type="checkbox" name="tyreType" value="tbr" checked={tyreType.value === 'tbr'} onChange={(e) => this.handleInputChange(e)} />
                  <span className="checkmark-radio" />
                </label>
                <span style={{ marginLeft: '10px' }}>TBR</span>
                &nbsp;&nbsp;&nbsp;
                <label className="custom-checkboax-radio--container">
                  <input type="checkbox" name="tyreType" value="tbb" checked={tyreType.value === 'tbb'} onChange={(e) => this.handleInputChange(e)} />
                  <span className="checkmark-radio" />
                </label>
                <span style={{ marginLeft: '10px' }}>TBB</span>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="c-top-15" style={{ marginLeft: '0px', marginRight: '0px' }}>
          <Col xl="8" md="8" sm="8" xs="8">
            <div>
              <Label className="enter-sale-label">
                Tyre Description<span className="required-field"> *</span>
              </Label>
              <Typeahead
                // labelKey="discription"
                options={skuData}
                placeholder="Type here"
                filterBy={['sku_id', 'discription']}
                labelKey={(option) => `${option.discription} - ${option.sku_id}`}
                onChange={(e) => { this.handleInputChange({ target: { name: 'tyreDescription', value: e && e[0] } }); }}
                selected={tyreDescription.value && tyreDescription.value.sku_id ? [tyreDescription.value] : []}
              />
              <div className="error-container">
                {tyreDescription.nullValue && <div className="error">{EMPTY_TYRE_DESCRIPTION}</div>}
              </div>
            </div>
          </Col>
          <Col>
            <div>
              <Label className="enter-sale-label">
                Qty<span className="required-field"> *</span>
              </Label>
              <Input
                type="number"
                name="tyreQuantity"
                id="tyreQuantity"
                placeholder="Type here"
                value={tyreQuantity.value}
                onChange={this.handleInputChange}
              />
              <div className="error-container">
                {tyreQuantity.nullValue && <div className="error">{EMPTY_QUANTITY}</div>}
              </div>
            </div>
          </Col>
        </Row> */}

          {tyreElements}
          {!isEdit && (
            <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
              <Col>
                <div>
                  <span
                    onClick={this.addTyreObject}
                    className="custom-anchor-tag"
                  >
                    + Add more entries
                  </span>
                </div>
              </Col>
            </Row>
          )}
          <Row
            className="c-top-15"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <Col>
              <Button
                //  disabled={!isValidForm}
                type="button"
                onClick={isEdit ? this.updateSale : this.saveSale}
                className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                color="warning"
                style={{ cursor: "pointer" }}
              >
                Save
              </Button>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default AddSalesDataFM;
